import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css'
import { GoogleOAuthProvider } from "@react-oauth/google";
import "react-toastify/dist/ReactToastify.css";
import { UserProvider } from "./UserContext";
import { BrowserRouter } from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="447583080212-4ogolh2nk8gob51hql04pu3v03bo0e53.apps.googleusercontent.com">
    <React.StrictMode>
      <HelmetProvider>
        <UserProvider>
          <BrowserRouter basename="/">
            <App />
          </BrowserRouter>
        </UserProvider>
      </HelmetProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);
// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
